/** Inline SVGs. Kept local so the app has no icon-font or CDN dependency. */

interface Props {
  size?: number;
  className?: string;
}

const stroke = (size: number, width: number, children: React.ReactNode, className?: string) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={width}
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const Regenerate = ({size = 11}: Props) =>
  stroke(size, 2.2, (
    <>
      <path d="M20 11a8 8 0 1 0-2.3 5.7" />
      <path d="M20 4v7h-7" />
    </>
  ));

export const Pencil = ({size = 11}: Props) => stroke(size, 2.2, <path d="M4 20h4L20 8l-4-4L4 16v4z" />);

export const Trash = ({size = 12}: Props) =>
  stroke(size, 2.2, <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" />);

export const Chevron = ({size = 11, className}: Props) =>
  stroke(size, 2.6, <path d="M15 6l-6 6 6 6" />, className);

export const Forward = ({size = 13}: Props) => stroke(size, 2.4, <path d="M9 6l6 6-6 6" />);

export const Download = ({size = 12}: Props) =>
  stroke(size, 2.2, <path d="M12 4v12M6 11l6 6 6-6M5 20h14" />);

export const ArchiveBox = ({size = 11}: Props) =>
  stroke(size, 2.2, <path d="M3 7h18v13H3zM3 7l2-3h14l2 3M10 12h4" />);

export const UploadArrow = ({size = 14}: Props) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#7C1F2E" strokeWidth={2} aria-hidden="true">
    <path d="M12 19V5M5 12l7-7 7 7" />
  </svg>
);

export const PlaceholderFrame = ({size = 24}: Props) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#9A8F86" strokeWidth={1.5} aria-hidden="true">
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M8 12h8M12 8v8" />
  </svg>
);

export const Speaker = ({size = 16, muted = false}: Props & {muted?: boolean}) =>
  stroke(
    size,
    2,
    muted ? (
      <>
        <path d="M11 5L6 9H3v6h3l5 4V5z" />
        <path d="M17 9l4 6M21 9l-4 6" />
      </>
    ) : (
      <>
        <path d="M11 5L6 9H3v6h3l5 4V5z" />
        <path d="M16 9a4 4 0 0 1 0 6" />
      </>
    ),
  );

export const Fullscreen = ({size = 15}: Props) =>
  stroke(size, 2, <path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5" />);

export const Close = ({size = 11}: Props) => stroke(size, 2.6, <path d="M6 6l12 12M18 6L6 18" />);

/** Four panes — the product chooser. Deliberately not an arrow: this leaves the
    app for a different site, and in an RTL layout a back-arrow points the wrong
    way for half the people reading it. */
export const Grid = ({size = 11}: Props) =>
  stroke(size, 2, (
    <>
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
    </>
  ));

export const Play = ({size = 12, fill = '#fff'}: Props & {fill?: string}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} aria-hidden="true">
    <path d="M7 4l13 8-13 8z" />
  </svg>
);

export const Pause = ({size = 12, fill = '#fff'}: Props & {fill?: string}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} aria-hidden="true">
    <path d="M7 4h4v16H7zM13 4h4v16h-4z" />
  </svg>
);
